  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="select-device-dlg-container">
    <div class="section-header" style="flex-basis: 30px;" data-cy="select-device-dlg-header">
      <div class="section-header-title" data-cy="select-device-dlg-title">
        Select Device
      </div>
      <div style="flex: 1;"></div>
    </div>

  <div style="flex-basis: 210px; display: flex; flex-direction: column; margin-left: 10px" data-cy="select-device-dlg-content">
    <div style="flex: 1;  margin-left: auto; margin-right: auto;" data-cy="select-device-dlg-selection-container">
      <div *ngIf="isErrorFindingDevices" style="width: fit-content; position: relative; margin-top: 80px; margin-left: auto; margin-right: auto;" data-cy="select-device-dlg-error-message">
        Unable to locate devices.
      </div>
      <div *ngIf="!isErrorFindingDevices" style=" margin: auto;" data-cy="select-device-dlg-dropdown-container">
        <mat-form-field class="device-input-field full-width" data-cy="select-device-dlg-form-field">
          <div *ngIf="devices" data-cy="select-device-dlg-select-container">
                <mat-select [(value)]="selectedDevice" data-cy="select-device-dlg-select">
                  <mat-option *ngFor="let device of devices; let i = index" [value]="device" data-cy="select-device-dlg-option-{{i}}">
                    {{device.Name}}
                  </mat-option>
                </mat-select>
          </div>
        </mat-form-field>
      </div>
    </div>
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="select-device-dlg-footer">
      <div style="display: flex; flex-basis: 44px; width: 100%; padding: 2px;" data-cy="select-device-dlg-buttons">
        <button (click)="cancel()" class="tdo-button tdo-close" style="margin-left: 270px; margin-right: 6px;" data-cy="select-device-dlg-cancel-button">Cancel</button>
        <button (click)="confirm()" class="tdo-button tdo-save" data-cy="select-device-dlg-ok-button">Ok</button>
      </div>
    </div>
  </div>
  </div>
